import { makeObservable, observable, action, computed, runInAction } from 'mobx';
import dayjs from 'dayjs';

import ChapterService from 'src/services/chapter';
import ChapterError from 'src/services/error/models/chapter';
import { ErrorToast } from 'src/libs/toast';

import ChapterCardViewModel from 'src/components/ChapterCards/ChapterCard/viewModel';
import playerViewModel from 'src/components/Player/viewModel';
import playerStore from 'src/components/Player/store';


export default class ChapterSectionViewModel {
  @observable cid;
  @observable duration;
  @observable chapterList = [];
  // NOTE:
  @observable lastIs = '';
  @observable nowPlaying = '';
  @observable count = 0;
  @observable anchor;

  @observable status = {
    isReady: false
  }

  constructor() {
    makeObservable(this);
  }

  @action
  didMount = async (data) => {
    try {
      this.cid = data.id;
      await this.getChapters();
      runInAction(() => {
        this.status.isReady = true;
      });
    } catch (error) {
      console.error(error);
    }
  }

  @action
  addEventListener = () => {
    playerViewModel.addListener('favorite', this.onFavorite);
    playerViewModel.addListener('changeChapter', this.changeLastIsFunc);
    playerViewModel.addListener('closePlayer', this.onPlayerClose);

  }

  @action
  removeEventListener = () => {
    playerViewModel.removeListener('favorite', this.onFavorite);
    playerViewModel.removeListener('changeChapter', this.changeLastIsFunc);
    playerViewModel.removeListener('closePlayer', this.onPlayerClose);
  }


  @action
  getChapters = async () => {
    try {
      const { list, courseInfo, anchor } = await ChapterService.getChapters(this.cid, this.anchor);
      runInAction(() => {
        this.nowPlaying = playerStore.chapter?.id ?? '';
        const newList = list.map((el) => new ChapterCardViewModel({
          ...el,
          courseId: courseInfo.id,
          saleType: courseInfo.saleType,
          isOwned: courseInfo.isOwned
        }));
        this.chapterList.push(...newList);
        this.anchor = anchor;
        this.duration = courseInfo.duration;
        this.count = courseInfo.count;
        this.lastIs = courseInfo.lastIs;
      });
    } catch (error) {
      ChapterError.getChapters(error);
    }
  }

  @action
  onEnter = async () => {
    try {
      if (!this.status.isReady) {
        return;
      }
      await this.getChapters();
    } catch (error) {
      // console.error(error);
    }
  }

  @action
  onFavorite = (data) => {
    const { id, res } = data;
    const { isFavorite } = res;

    const target = this.chapterList.find((chapter) => chapter.id === id);
    if (target) {
      target.isFavorite = isFavorite;
    }
  }

  @action
  changeLastIsFunc = (data) => {
    const { uid, tid } = data;
    this.nowPlaying = tid;
    if (uid) {
      this.lastIs = tid;
      const target = this.chapterList.find((chapter) => chapter.id === tid);
      target?.changeOnPlay();
    }
  }

  @action
  onPlayerClose = () => {
    this.nowPlaying = '';
  }

  @computed
  get totalLength() {
    const hours = Math.floor(dayjs.duration(this.duration, 'second').asHours());
    const minutes = dayjs.duration(this.duration, 'second').minutes();
    const seconds = dayjs.duration(this.duration, 'second').seconds();

    if (hours < 1) {
      return `${minutes}分 ${seconds}秒`;
    }

    if (hours >= 1 && minutes < 1) {
      return `${hours}時 ${seconds}秒`;
    }

    return `${hours}時 ${minutes}分 ${seconds}秒`;
  }
}
